import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest } from "../_helpers/apiConfig";
import { toast } from "react-toastify";

export const getBannerList = createAsyncThunk(
  "/banner/list",
  async (filters) => {
    const response = await apiRequest("POST", "/v1/banner/list", filters);
    return response;
  },
);

export const getBannerCount = createAsyncThunk(
  "/banner/getCount",
  async (filters) => {
    const response = await apiRequest("POST", "/v1/banner/getCount", filters);
    return response;
  },
);

export const saveBannerPlan = createAsyncThunk(
  "/banner/saveAdminBanner",
  async (arg, thunkAPI) => {
    const { Payload } = arg;
    const response = await apiRequest(
      "POST",
      "v1/banner/saveAdminBanner",
      Payload,
    );
    if (response.message) {
      thunkAPI.dispatch(getBannerList());
    }
    return response;
  },
);

export const savePlans = createAsyncThunk(
  "/banner/saveBannerPlan",
  async (arg, thunkAPI) => {
    const { Payload } = arg;
    const response = await apiRequest(
      "POST",
      "v1/banner/saveBannerPlan",
      Payload,
    );
    if (response.message) {
      thunkAPI.dispatch(getPlanList());
    }
    return response;
  },
);

export const disableEnablePlan = createAsyncThunk(
  "/banner/disableEnablePlan",
  async (arg, thunkAPI) => {
    const response = await apiRequest(
      "POST",
      "v1/banner/disableEnablePlan",
      arg,
    );
    toast.info(response?.message || "Plan deleted Successfully");
    thunkAPI.dispatch(getPlanList());
    return response;
  },
);

export const bannerStatusUpdate = createAsyncThunk(
  "/banner/bannerStatusUpdate",
  async (arg, thunkAPI) => {
    const { payload, filter } = arg;
    const response = await apiRequest(
      "POST",
      "v1/banner/bannerStatusUpdate",
      payload,
    );
    if (response.message) {
      toast.info(response?.message || "Status Update  Successfully");
      thunkAPI.dispatch(getBannerList(filter));
    }
    return response;
  },
);

export const boostListAdmin = createAsyncThunk(
  "/banner/boostListAdmin",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/banner/boostListAdmin",
      filters,
    );
    return response;
  },
);

export const boostStatusUpdate = createAsyncThunk(
  "/banner/boostStatusUpdate",
  async (arg, thunkAPI) => {
    const { Payload } = arg;
    const response = await apiRequest(
      "POST",
      "v1/banner/boostStatusUpdate",
      Payload,
    );
    if (response.message) {
      toast.info(response?.message || "Status Update  Successfully");
      thunkAPI.dispatch(boostListAdmin());
    }
    return response;
  },
);

export const getPlanList = createAsyncThunk(
  "/banner/getPlanList",
  async (filters = {}) => {
    const response = await apiRequest(
      "POST",
      "/v1/banner/getPlanList",
      filters,
    );
    return response;
  },
);

export const advertisementList = createAsyncThunk(
  "/banner/advertisementList",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/banner/advertisementList",
      filters,
    );
    return response;
  },
);

export const actionByAdminOnPromotions = createAsyncThunk(
  "/banner/actionByAdminOnPromotions",
  async (payload) => {
    const response = await apiRequest(
      "POST",
      "/v1/banner/actionByAdminOnPromotions",
      payload,
    );
    return response;
  },
);

export const saveNewAdvertisementFromAdminSide = createAsyncThunk(
  "/banner/saveAdminAdvertisement",
  async (arg, thunkAPI) => {
    const { Payload } = arg;
    const response = await apiRequest(
      "POST",
      "v1/banner/saveAdminAdvertisement",
      Payload,
    );

    return response;
  },
);

export const advertisementStatusUpdate = createAsyncThunk(
  "/banner/advertisementStatusUpdate",
  async (arg, thunkAPI) => {
    const { payload, filter } = arg;
    const response = await apiRequest(
      "POST",
      "v1/banner/advertisementStatusUpdate",
      payload,
    );
    if (response.message) {
      toast.info(response?.message || "Status Update  Successfully");
      thunkAPI.dispatch(advertisementList(filter));
    }
    return response;
  },
);

const bannerSlice = createSlice({
  name: "banner",
  initialState: {
    bannerList: [],
    newBannerList: [],
    planList: [],
    totalPlan: null,
    totalBanner: null,
    boostList: [],
    totalBoostList: null,
    loading: false,
    error: null,
    advertisements: [],
    advertisementTotal: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBannerList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBannerList.fulfilled, (state, action) => {
        state.loading = false;
        state.bannerList = action?.payload?.data?.list;
        state.totalBanner = action?.payload?.data?.total;
      })
      .addCase(getBannerList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getBannerCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBannerCount.fulfilled, (state, action) => {
        state.loading = false;
        state.bannerCount = action?.payload?.data;
      })
      .addCase(getBannerCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(saveBannerPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveBannerPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.newBannerList = action?.payload?.data?.list;
        state.totalBanner = action?.payload?.data?.total;
      })
      .addCase(saveBannerPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(savePlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(savePlans.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(savePlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(boostListAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(boostListAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.boostList = action?.payload?.data?.list;
        state.totalBoostList = action?.payload?.data?.total;
      })
      .addCase(boostListAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(getPlanList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlanList.fulfilled, (state, action) => {
        state.loading = false;
        state.planList = action?.payload?.data?.list;
        state.totalPlan = action?.payload?.data?.total;
      })
      .addCase(getPlanList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(advertisementList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(advertisementList.fulfilled, (state, action) => {
        state.loading = false;
        state.advertisements = action?.payload?.data?.list;
        state.advertisementTotal = action?.payload?.data?.total;
      })
      .addCase(advertisementList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default bannerSlice.reducer;
